module.exports = __webpack_public_path__ + "img/eurotext_logo.6542d18c.png";